/**
 * Returns count of how many visits with exact same time exist in sequence at
 * the end of the visit list.
 *
 * Used for determining limit/offset for retrieving new visits during infinite scroll
 * @param visits
 * @returns {number}
 */
export const countConcurrentVisitsAtEnd = (visits, dateSelector = (obj) => obj.visits[0].due_at) => {
    var arr = [];
    for (let key in visits) {
        if (!visits.hasOwnProperty(key)) { continue; }

        arr.push(key);
    }

    let previousValue = null;
    let identicialValuesFound = 0;

    for (let i = arr.length - 1; i >= 0; i--) {
        let objKey = arr[i];

        //let thisDateTime = visits[objKey].visits[0].due_at;
        let thisDateTime = dateSelector(visits[objKey]);

        if (previousValue == null || thisDateTime === previousValue) {
            identicialValuesFound++;
            previousValue = thisDateTime;
        } else {
            break;
        }
    }

    return identicialValuesFound;
}

export const countConcurrentVisitsAtStart = (visits, dateSelector = (obj) => obj.visits[0].due_at) => {
    let previousValue = null;
    let identicialValuesFound = 0;

    for (let objKey in visits) {
        if (!visits.hasOwnProperty(objKey)) { continue; }

        //let thisDateTime = visits[objKey].visits[0].due_at;
        let thisDateTime = dateSelector(visits[objKey]);
        if (previousValue == null || thisDateTime === previousValue) {
            identicialValuesFound++;
            previousValue = thisDateTime;
        } else {
            break;
        }
    }

    return identicialValuesFound;
}
